import { Flex, Text, useColorModeValue } from '@chakra-ui/react';

export default function Footer() {
	const textColor = useColorModeValue('secondaryGray.700', 'white');
	return (
		<Flex
			zIndex='3'
			flexDirection={{ base: 'column', md: 'row' }}
			alignItems={{ base: 'center', md: 'center' }}
			justifyContent='space-between'
			px={{ base: '30px', md: '50px' }}
			pb='30px'
			pt='10px'>
			<Text color={textColor} fontSize='sm'>
				&copy; {new Date().getFullYear()} Datric. Todos os direitos reservados.
			</Text>
		</Flex>
	);
}
